<div [hidden]="mode != 'LOGIN'" class="container">
  <div class="row">
    <div class="col-md-3 col-sm-3"></div>
    <div class="col-md-6 col-sm-6">
      <div class="card card-signin my-5"> 
        <div class="card-body">
          <img [src]="imzayeriLogoUrl" class="center-image">
          <br>
          <h1 class="text-center">{{title}}</h1>
          <form class="form-signin" #fLogin="ngForm" (ngSubmit)="onLoginSubmit()" ngNativeValidate>
            <button [disabled]="loginLoading" class="btn btn-lg btn-primary text-uppercase signin-button" type="submit">{{translate.instant("Login")}}</button>
            <div [hidden]="!loginLoading" class="loader"></div>
          </form>
          <hr style="border-top:1px solid #3800ff !important;">
          <div class="row mb-3">
            <div class="col-md-12">
              <div style="float: right;" (click)="mode='FORGOT_PASSWORD'">
                <a>{{translate.instant("Forgot Password")}}</a>
              </div>
              <div style="float: left;" (click)="mode='REGISTER'">
                <a>{{translate.instant("Register")}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3 col-sm-3"></div>
  </div>
</div>

<div [hidden]="mode != 'REGISTER'" class="container">
  <div class="row">
    <div class="col-md-3 col-sm-3"></div>
    <div class="col-md-6 col-sm-6">
      <div class="card card-signin my-5"> 
        <div class="card-body">
          <img [src]="imzayeriLogoUrl" class="center-image">
          <br>
          <h1 class="text-center">{{translate.instant("Register")}}</h1>
          <form class="form-signin" #f="ngForm" (ngSubmit)="onRegisterSubmit(f)" ngNativeValidate>
            
            <label for="email">{{translate.instant("Email address")}}</label>
            <div class="form-label-group">
              <input type="email" name="email" id="email" class="form-control" [placeholder]="translate.instant('Email address')" autofocus ngModel required #email="ngModel">
            </div>
            
            <label for="fullname">{{translate.instant("Full Name")}}</label>
            <div class="form-label-group">
              <input type="text" name="fullname" id="fullname" class="form-control" [placeholder]="translate.instant('Full Name')" ngModel required #fullname="ngModel">
            </div>
            
            <label for="mobile">{{translate.instant("Mobile Phone Number")}}</label>
            <div class="form-label-group">
              <input type="tel" name="mobile" id="mobile" class="form-control" [placeholder]="translate.instant('Mobile Phone (Optional)')" ngModel #mobile="ngModel">
            </div>

            <label for="password">{{translate.instant('Password')}}</label>
            <div class="form-label-group">
              <input type="password" name="password" id="password" class="form-control" [placeholder]="translate.instant('Password')" ngModel required [(ngModel)]="registerPasswordFirst" minlength="8" (ngModelChange)="onPasswordInputChange()">
            </div>
            <div class="row" style="margin: 2px;text-align: center;">
              <!-- <div class="col-md-3" style="border: 1px solid #000000; font-weight: bold;" [ngClass]="{'password-condition-met':!passwordErrorUppercase,'password-condition-not-met':passwordErrorUppercase}">Uppercase</div> -->
              <div class="col-md-6" style="border: 1px solid #000000; font-weight: bold;" [ngClass]="{'password-condition-met':!passwordErrorLowerCase,'password-condition-not-met':passwordErrorLowerCase}">{{translate.instant('Lowercase')}}</div>
              <div class="col-md-6" style="border: 1px solid #000000; font-weight: bold;" [ngClass]="{'password-condition-met':!passwordErrorNumber,'password-condition-not-met':passwordErrorNumber}">{{translate.instant('Number')}}</div>
              <!-- <div class="col-md-3" style="border: 1px solid #000000; font-weight: bold;" [ngClass]="{'password-condition-met':!passwordErrorSpecial,'password-condition-not-met':passwordErrorSpecial}">Special</div> -->
            </div><br>
            
            <div class="row mb-3">
              <div class="col-md-12">
                <input type="checkbox" id="acceptTerms" name="acceptTerms" ngModel #acceptTerms="ngModel" required>&nbsp;
                <label class="float-right" for="rememberCheckBox" [innerHTML]="'TERMS_OF_USE' | translate:{link:termsOfUseLink}"></label>
              </div>
            </div>
            <br>

            <button [hidden]="registerLoading" class="btn btn-lg btn-primary text-uppercase signin-button" type="submit">{{translate.instant('Register')}}</button>
            <div [hidden]="!registerLoading" class="loader"></div>
          </form>
          <hr style="border-top:1px solid #3800ff !important;">
          <div [hidden]="!showRegisterPasswordError" class="reset-password-error">
            {{registerPasswordErrorText}}
          </div>
          <div (click)="mode='LOGIN'">
            <a>{{translate.instant('Login')}}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3 col-sm-3"></div>
  </div>
</div>

<div [hidden]="mode != 'FORGOT_PASSWORD'" class="container">
  <div class="row">
    <div class="col-md-3 col-sm-3"></div>
    <div class="col-md-6 col-sm-6">
      <div class="card card-signin my-5"> 
        <div class="card-body">
          <img [src]="imzayeriLogoUrl" class="center-image">
          <br>
          <h1 class="text-center">{{title}}</h1>
          <form class="form-signin" #forgotLogin="ngForm" (ngSubmit)="onForgotPasswordSubmit(forgotLogin)" ngNativeValidate>
            
            <label for="email">{{translate.instant('Email address')}}</label>
            <div class="form-label-group">
              <input type="email" name="emailForgotPassword" id="emailForgotPassword" class="form-control" [placeholder]="translate.instant('Email address')" autofocus ngModel required #emailForgotPassword="ngModel">
            </div>
            
            <button [disabled]="forgotPasswordButtonDisabled" class="btn btn-lg btn-primary text-uppercase signin-button" type="submit">{{translate.instant('Send Email')}}</button>
            <div [hidden]="!forgotLoading" class="loader"></div>
          </form>
          <hr style="border-top:1px solid #3800ff !important;">
          <div (click)="mode='LOGIN'">
            <a>{{translate.instant('Login')}}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3 col-sm-3"></div>
  </div>
</div>

<div [hidden]="mode != 'RESET_PASSWORD'" class="container">
  <div class="row">
    <div class="col-md-3 col-sm-3"></div>
    <div class="col-md-6 col-sm-6">
      <div class="card card-signin my-5"> 
        <div class="card-body">
          <img [src]="imzayeriLogoUrl" class="center-image">
          <br>
          <h1 class="text-center">{{title}}</h1>
          <form class="form-signin" #resetLogin="ngForm" (ngSubmit)="onResetPasswordSubmit(resetLogin)" ngNativeValidate>
            
            <label for="passwordReset">{{translate.instant('Password')}}</label>
            <div class="form-label-group">
              <input type="password" name="passwordReset" id="passwordReset" class="form-control" [placeholder]="translate.instant('Password')" autofocus [(ngModel)]="resetPasswordFirst" required #passwordReset="ngModel" minlength="8" (ngModelChange)="onPasswordInputChange()">
            </div>

            <div class="row" style="margin: 2px;text-align: center;">
              <!-- <div class="col-md-3" style="border: 1px solid #000000; font-weight: bold;" [ngClass]="{'password-condition-met':!passwordErrorUppercase,'password-condition-not-met':passwordErrorUppercase}">Uppercase</div> -->
              <div class="col-md-6" style="border: 1px solid #000000; font-weight: bold;" [ngClass]="{'password-condition-met':!passwordErrorLowerCase,'password-condition-not-met':passwordErrorLowerCase}">{{translate.instant('Lowercase')}}</div>
              <div class="col-md-6" style="border: 1px solid #000000; font-weight: bold;" [ngClass]="{'password-condition-met':!passwordErrorNumber,'password-condition-not-met':passwordErrorNumber}">{{translate.instant('Number')}}</div>
              <!-- <div class="col-md-3" style="border: 1px solid #000000; font-weight: bold;" [ngClass]="{'password-condition-met':!passwordErrorSpecial,'password-condition-not-met':passwordErrorSpecial}">Special</div> -->
            </div>

            <br>
            <label for="passwordResetAgain">{{translate.instant('Password Again')}}</label>
            <div class="form-label-group">
              <input type="password" name="passwordResetAgain" id="passwordResetAgain" class="form-control" [placeholder]="translate.instant('Password Again')" autofocus ngModel required #passwordResetAgain="ngModel" minlength="8">
            </div>

            <hr style="border-top:1px solid #3800ff !important;">
            <div [hidden]="!showResetPasswordError" class="reset-password-error">
              {{resetPasswordErrorText}}
            </div>
            <button [disabled]="passwordResetLoading" class="btn btn-lg btn-primary text-uppercase signin-button" type="submit">{{translate.instant("Save")}}</button>
            <div [hidden]="!passwordResetLoading" class="loader"></div>
          </form>
        </div>
      </div>
    </div>
    <div class="col-md-3 col-sm-3"></div>
  </div>
</div>